export const SUBSCRIPTION_DATA_RECEIVED = "SUBSCRIPTION_DATA_RECEIVED";
export const SUBSCRIPTION_DATA_REMOVED = "SUBSCRIPTION_DATA_REMOVED";
export const SUBSCRIPTION_DATA_UPDATED = "SUBSCRIPTION_DATA_UPDATED";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const SUBSCRIPTION_DATA_BATCH_RECEIVED = "SUBSCRIPTION_DATA_BATCH_RECEIVED";
